import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { contentStyles, paragraphLarge } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  color: var(--fgColor);

  ${ButtonStyles.Button} {
    margin-top: ${fluid(24, 32)};
  }
`;
const Inner = styled.div `
  margin: 0 auto;

  ${Container}:not([data-layout]) & {
    max-width: 89ch;
  }
`;
const Content = styled.div `
  ${contentStyles};

  a,
  p a {
    color: ${brand.white};
    text-decoration-color: ${brand.primary.beige};

    &:focus {
      outline: auto;
      outline-color: currentColor;
      outline-offset: 5px;
      outline-width: thin;
    }
  }

  .paragraph-large {
    ${paragraphLarge};
  }
`;
const ButtonWrapper = styled.div `
  &[data-cta-align='center'] {
    text-align: center;
  }

  &[data-cta-align='right'] {
    text-align: right;
  }
`;
const RichTextStyles = {
    ButtonWrapper,
    Container,
    Content,
    Inner,
};
export default RichTextStyles;
